import api from 'service/api'

const dponetAPI = api.create('dponet', false)

const getCompany = async ({ companyId = '', params = {} }) => {
  return dponetAPI.get(`/backoffice/companies/${companyId}/dai_opt_out`, {
    params,
  })
}

const manageCompany = async ({ companyId = '', daiOptOut = {} }) => {
  return dponetAPI.patch(`/backoffice/companies/${companyId}/dai_opt_out`, {
    daiOptOut,
  })
}

const getOrganization = async ({ organizationId = '', params = {} }) => {
  return dponetAPI.get(
    `/backoffice/organizations/${organizationId}/dai_opt_out`,
    { params },
  )
}

const manageOrganization = async ({ organizationId = '', daiOptOut = {} }) => {
  return dponetAPI.patch(
    `/backoffice/organizations/${organizationId}/dai_opt_out`,
    {
      daiOptOut,
    },
  )
}

const daiOptOuts = {
  getCompany,
  manageCompany,
  getOrganization,
  manageOrganization,
}

export default daiOptOuts
